import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './TimeStamp.st.css';
var TimeStamp = function (props) {
    var _a;
    var _b = props.context, currentTimeFormatted = _b.currentTimeFormatted, durationFormatted = _b.durationFormatted, remainingFormatted = _b.remainingFormatted, isLiveStream = _b.isLiveStream;
    var display = isLiveStream ? 'currentTime' : props.display;
    return (React.createElement("span", { className: classes.time + " " + props.className, "data-hook": props.dataHook }, props.duration ||
        (_a = {},
            _a['full'] = currentTimeFormatted + " / " + durationFormatted,
            _a['duration'] = "" + durationFormatted,
            _a['currentTime'] = "" + currentTimeFormatted,
            _a['remaining'] = "-" + remainingFormatted,
            _a)[display || 'full']));
};
TimeStamp.displayName = 'TimeStamp';
TimeStamp.defaultProps = {
    className: '',
    dataHook: '',
    display: 'full',
};
export default withPlaybackContext(TimeStamp);
//# sourceMappingURL=TimeStamp.js.map